import $ from 'jquery';

class AdjusterSearch {

  constructor() {}

  init() {
    this.$searchArea = $('div#adjuster_search_area');
    if (this.$searchArea.length === 0) return;

    this.$qsForm = this.$searchArea.find('#quick_search_form');
    this.$msForm = this.$searchArea.find('#multi_search_form');

    this.$toQsLink = this.$searchArea.find('a#toQuickSearch');
    this.$toMsLink = this.$searchArea.find('a#toMultipleSearch');
  }

  setupEvents() {
    if (this.$searchArea.length === 0) return;

    this.$toMsLink.click(e => {
      this.$msForm.removeClass('d-none');
      this.$qsForm.addClass('d-none');
    });

    this.$toQsLink.click(e => {
      this.$qsForm.removeClass('d-none');
      this.$msForm.addClass('d-none');
    });
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new AdjusterSearch();
